<template>
    <div class="reportdataCar">
        <div class="titlePage">Reportes de Caracterización - {{this.DataList.NameCharact}}</div>
        <div class="col-md-6 text-left">
            <router-link to="/admin/ReportCharacterization/">
                <button class="loginbtn primaryBtn primaryBtn">
                    <va-icon name="fa fa-arrow-left" size="60" /> Regresar
                </button>
            </router-link>
        </div>
        <br><br>
        <div class="listData" v-if="!noDtaForm">
            <DataList
                :InfoView="this.DLDataList"
                :HeadTable="this.HDDataList"
                :Report="this.nameReport"
                v-if="renderComponent1"
            />
        </div>
    </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
import DataList from '@/components/data-tables/DataListCharact.vue'

export default {
  name: 'reportdataCar',
  components: {
    DataList,
  },
  data () {
    return {
      nameReport: '',
      renderComponent1: false,
      DataList: [],
      HDDataList: [],
      DLDataList: [],
      noDtaForm: false,
    }
  },
  methods: {
    loadTableData: function () {
      this.HDDataList.push(
        { name: 'IdPersonCharact', title: 'Id', width: '10%' },
        { name: 'DatePersonCharact', title: 'Fecha de Creación', width: '10%' },
        { name: 'IdBanner', title: 'Id Banner', width: '10%' },
      )
      for (var i = 0; i < this.DataList.FormCharact.length; i++) {
        this.HDDataList.push({
          name: 'id_' + this.DataList.FormCharact[i].IdCharactForm,
          title: this.DataList.FormCharact[i].NamCharactForm,
          width: '10%',
        })
      }
      if (this.DataList.DataCharact) {
        this.nameReport = this.DataList.NameCharact
        for (var j = 0; j < this.DataList.DataCharact.length; j++) {
          var reloadDat = JSON.parse(this.DataList.DataCharact[j].DetPersonCharact)
          this.DLDataList.push(reloadDat)
          this.DLDataList[j].IdPersonCharact = this.DataList.DataCharact[j].IdPersonCharact
          this.DLDataList[j].DatePersonCharact = this.DataList.DataCharact[j].DatePersonCharact
          this.DLDataList[j].IdBanner = this.DataList.DataCharact[j].IdBanner
        }
      }
    },
  },
  created: function () {
    let loader = this.$loading.show()
    var datCaract = IberoHelpers.getDatCaractbyId(this.$store, this.$route.params.idCaract, this.$route.params.idReference)
    datCaract.then(Response => {
      if (Response.data) {
        this.DataList = Response.data.Characterizations[0]
        this.noDtaForm = false
        this.loadTableData()
        IberoHelpers.forceRerender1(this)
        DataList.data().reportCaract = true
      }
      loader.hide()
    })
  },
}
</script>